import React from "react";
import { Container } from "@material-ui/core";
import PageTitle from "../../../components/pageTitle/PageTitle";


const IssuesAlertPage = () => {

    return (
        <Container>
            <PageTitle
                pageTitle={`Issues Alerts`}
                showBreadcrumb={[
                    { label: "Home", to: "/" },
                ]}
                BreadCrumbCurrentPageTitle={"Issues Alerts"}
                showLastSeen={true}
            />
            <div className="sectionBox">

            </div>
        </Container>
    )
}
export default IssuesAlertPage;